export default __webpack_public_path__ + "static/media/d3a31aa408256ad110b3cd9953716ba1.png";